if (!customElements.get('stick-button')) {
  class StickButton extends HTMLElement {
    constructor() {
      super();
      this.normalButton = document.querySelector('[data-button="normal"]');

      this.setupMobileStickButton();
    }
    setupMobileStickButton() {
      // Create a new IntersectionObserver instance to observe the visibility of the button 
      const normalButtonObserver = new IntersectionObserver(
        (entries) => {
          // Loop through each entry (element being observed)
          entries.forEach((entry) => {
            // Check if the element is intersecting the viewport
            if (entry.isIntersecting) {
              this.removeAttribute('data-show');
            } else {
              this.setAttribute('data-show', '');
            }
          });
        },
        {
          // Set the threshold to 0.2, meaning the callback will be executed when 20% of the target element is visible
          threshold: 0.2,
        }
      );

      // Start observing the button element
      normalButtonObserver.observe(this.normalButton);
    }
  }

  customElements.define('stick-button', StickButton);
}
